// Hide Yotpo reviews widget when showing 0 reviews
document.addEventListener('DOMContentLoaded', function() {
  function hideZeroReviews() {
    const reviewTexts = document.querySelectorAll('.yotpo-sr-bottom-line-text');
    
    reviewTexts.forEach(textElement => {
      const zeroReviewsRegex = /^\s*0\s+reviews?\s*$/i;
      
      if (zeroReviewsRegex.test(textElement.textContent) || textElement.textContent == '(0)') {
        textElement.classList.add('yotpo-sr-bottom-line-text--zero-reviews');
        
        // Also hide the parent right panel
        const rightPanel = textElement.closest('.yotpo-sr-bottom-line-right-panel');
        if (rightPanel) {
          rightPanel.classList.add('yotpo-sr-bottom-line-right-panel--zero-reviews');
        }
        
        // Also hide the star container
        const summaryContainer = textElement.closest('.yotpo-sr-bottom-line-summary');
        if (summaryContainer) {
          summaryContainer.classList.add('yotpo-sr-bottom-line-summary--zero-reviews');
        }
      }
    });
  }

  // Run immediately
  hideZeroReviews();

  // Also run when Yotpo content loads dynamically
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        hideZeroReviews();
      }
    });
  });

  // Observe changes to the document body
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
